





















import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';

const cssPrefix = 'terms-condition';

@Component({
  components: {
    ...UUIFComponents,
  },
})
export default class TermsCondition extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  @Prop()
  showTNCDialogFlag: boolean;
  @Prop()
  tcConditions : string;
  closeDialog() {
    this.$emit('closeDialog');
  }
  downloadFile() {
    this.$emit('accept');
  }
}
